import type { ColorMode } from "@chakra-ui/react";

export type ThemePreference = "light" | "dark" | "system";
export type ThemePreferenceWithTimestamp = {
  theme: ThemePreference;
  lastUpdated: number;
};

const THEME_STORAGE_KEY = "layla-theme-preference";

export const getSystemTheme = (): ColorMode => {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

export const saveThemePreference = (preference: ThemePreference): void => {
  if (typeof window === "undefined") return;
  const preferenceWithTimestamp: ThemePreferenceWithTimestamp = {
    theme: preference,
    lastUpdated: Date.now(),
  };
  localStorage.setItem(
    THEME_STORAGE_KEY,
    JSON.stringify(preferenceWithTimestamp)
  );
};

export const getSavedThemePreference = (): ThemePreference | null => {
  if (typeof window === "undefined") return null;
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (!saved) return null;
  try {
    const parsed = JSON.parse(saved) as ThemePreferenceWithTimestamp;
    return parsed.theme;
  } catch {
    return null;
  }
};

export const clearThemePreference = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(THEME_STORAGE_KEY);
};
